import { render } from "./PedidoImportarColombia.vue?vue&type=template&id=08e5eb18&scoped=true"
import script from "./PedidoImportarColombia.vue?vue&type=script&lang=js"
export * from "./PedidoImportarColombia.vue?vue&type=script&lang=js"

import "./PedidoImportarColombia.vue?vue&type=style&index=0&id=08e5eb18&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e5eb18"]])

export default __exports__